import { toast } from '#/utils/toast';

/**
 * SideMsg workflow 樂觀鎖時間。列表缺 `record.updatedAt` 時才 fallback get_detail（一次）。
 * @returns {Promise<string|null>}
 */
export async function resolveDocumentUpdatedAt(row, { fetchDetail, setSelectedData } = {}) {
  const fromRow = row?.record?.updatedAt ?? row?.updatedAt;
  if (fromRow) {
    return fromRow;
  }

  if (!row?.id || typeof fetchDetail !== 'function') {
    toast.error('無法取得單據版本，請重新整理列表後再試');
    return null;
  }

  toast.info('列表缺版本時間，正在取得單據詳情…');

  try {
    const result = await fetchDetail(row.id);
    const detail = result?.data ?? {};
    const updatedAt = detail.record?.updatedAt ?? detail.updatedAt;
    if (!updatedAt) {
      toast.error('無法取得單據版本，請重新整理列表後再試');
      return null;
    }

    if (typeof setSelectedData === 'function') {
      setSelectedData({ ...row, ...detail });
    }

    return updatedAt;
  } catch {
    toast.error('取得單據詳情失敗，請稍後再試');
    return null;
  }
}
